import { useState } from 'react';
import { useSelector } from 'react-redux';

import { Avatar, Icon, Modal, Tooltip } from '@components/index';
import { AccountType, OrgRoleType } from '@constants/generic';
import EditOrganization from '@layouts/main-header/components/EditOrganization';

import theme from '../../../themes/colors';

const OrgDetails = () => {
  const { currentOrg } = useSelector((state: any) => state.user);

  const [showOrganizationDetailsModal, setShowOrganizationDetailsModal] =
    useState(false);

  const userRole = currentOrg?.role as OrgRoleType;

  const showOrgEditButton = [
    OrgRoleType.OWNER,
    OrgRoleType.ORGANISATION_ADMIN,
    OrgRoleType.INDIVIDUAL
  ].includes(userRole);

  const onCancelModal = () => {
    setShowOrganizationDetailsModal(false);
  };

  const disaplayName =
    currentOrg?.type === AccountType.INDIVIDUAL
      ? currentOrg?.display_name || ''
      : currentOrg?.name || '';

  return (
    <div className="flex items-center gap-2 p-4">
      <Avatar
        name={disaplayName}
        className="size-8 min-w-8 rounded-lg text-theme"
        imageUrl={currentOrg?.image_url}
        bgColor={theme.cofeePurple50}
        textClassName="text-lg font-medium text-cofeeNeutral10"
      />
      <div className="flex w-full max-w-36 items-center justify-between gap-2">
        <div className="truncate break-words font-medium text-cofeeNeutral10">
          {disaplayName}
        </div>
        {showOrgEditButton && (
          <>
            <div
              className="flex !size-8 cursor-pointer items-center justify-center rounded-lg hover:bg-cofeeGreyBlue75"
              onClick={() => setShowOrganizationDetailsModal(true)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  setShowOrganizationDetailsModal(true);
                }
              }}
              tabIndex={0}
              role="button"
              data-tooltip-id="edit-org-icon"
            >
              <Icon name="edit-pencil" size="16" />
            </div>
            <Tooltip id="edit-org-icon" type="text" tooltipText="Edit" />
          </>
        )}
      </div>
      {showOrganizationDetailsModal && (
        <Modal isOpen={showOrganizationDetailsModal} onCancel={onCancelModal}>
          <EditOrganization
            imageUrl={currentOrg?.image_url || ''}
            currentOrgName={disaplayName}
            currentOrgId={currentOrg?.id || ''}
            handleCancel={onCancelModal}
            accountType={currentOrg?.type || AccountType.ORGANIZATION}
          />
        </Modal>
      )}
    </div>
  );
};

export default OrgDetails;
